module.exports = __webpack_public_path__ + "img/export_group.98acda96.svg";